import axiosInstance from './axiosConfig';

const API_URL = '/api/elements';

// Получить все элементы (для админов)
const getAllElements = (params = {}) => {
  return axiosInstance.get(API_URL, { params });
};

// Получить элемент по ID
const getElementById = (id) => {
  return axiosInstance.get(`${API_URL}/${id}`);
};

// Получить элемент по elementCode
const getElementByCode = async (elementCode) => {
  const response = await axiosInstance.get(`${API_URL}/by-code/${elementCode}`);
  return response.data;
};

// Получить элементы для конфигуратора (только активные)
const getElementsForConfigurator = (mode = null) => {
  const params = mode ? { mode } : {};
  return axiosInstance.get(`${API_URL}/configurator`, { params });
};

// Создать новый элемент (с загрузкой файлов)
const createElement = (elementData, files = {}) => {
  const formData = new FormData();
  
  // Добавляем данные элемента как JSON
  formData.append('data', JSON.stringify(elementData));
  
  // Добавляем файлы
  if (files.svg) {
    formData.append('svg', files.svg);
  }
  if (files.icon) {
    formData.append('icon', files.icon);
  }
  
  return axiosInstance.post(API_URL, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

// Обновить элемент (с загрузкой файлов)
const updateElement = (id, elementData, files = {}) => {
  const formData = new FormData();
  
  // Добавляем данные элемента как JSON
  formData.append('data', JSON.stringify(elementData));
  
  // Добавляем файлы
  if (files.svg) {
    formData.append('svg', files.svg);
  }
  if (files.icon) {
    formData.append('icon', files.icon);
  }
  
  return axiosInstance.put(`${API_URL}/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

// Удалить элемент
const deleteElement = (id) => {
  return axiosInstance.delete(`${API_URL}/${id}`);
};

// Переключить активность элемента
const toggleElementActive = (id, isActive) => {
  return axiosInstance.patch(`${API_URL}/${id}/toggle-active`, { isActive });
};

const elementService = {
  getAllElements,
  getElementById,
  getElementByCode,
  getElementsForConfigurator,
  createElement,
  updateElement,
  deleteElement,
  toggleElementActive,
};

export default elementService;

export { getElementByCode };

